import { render, staticRenderFns } from "./BrickSquareBase.vue?vue&type=template&id=246a5d57&scoped=true&"
import script from "./BrickSquareBase.vue?vue&type=script&lang=js&"
export * from "./BrickSquareBase.vue?vue&type=script&lang=js&"
import style0 from "./BrickSquareBase.vue?vue&type=style&index=0&id=246a5d57&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246a5d57",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('246a5d57')) {
      api.createRecord('246a5d57', component.options)
    } else {
      api.reload('246a5d57', component.options)
    }
    module.hot.accept("./BrickSquareBase.vue?vue&type=template&id=246a5d57&scoped=true&", function () {
      api.rerender('246a5d57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Patterns/BrickSquareBase.vue"
export default component.exports